import { level, linePlot, periodInput } from "../definitionHelpers";
import { PALETTE } from "../palette";
import { MA_TYPE } from "../indicatorTypes";
import { valuesReader } from "../math/priceSources";
import { fillMovingAverage } from "../math/movingAverages";
import { fillMacdLine } from "../math/macd";
import { highestAt, lowestAt } from "../math/windowExtremes";
import { stochasticAt } from "../math/stochastic";

// Stochastic of `source` over `period` values into `target`, smoothed by an EMA into `smoothed`
const fillSmoothedStochastic = ({ source, target, smoothed, period, smoothing, fromIndex, toIndex }) => {
  const read = valuesReader(source);

  for (let index = fromIndex; index < toIndex; index += 1) {
    const highest = highestAt(read, index, period);

    target[index] = stochasticAt(source[index], highest, lowestAt(read, index, period), target[index - 1]);
  }

  fillMovingAverage({
    type: MA_TYPE.EMA,
    read: valuesReader(target),
    target: smoothed,
    period: smoothing,
    fromIndex,
    toIndex,
  });
};

/**
 * Schaff Trend Cycle (research §1.4). Not in TradingView, the classic
 * formula (Doug Schaff): the stochastic of the MACD line (Fast / Slow EMA)
 * over Cycle bars smoothed by an EMA over %D (MACD), the stochastic of that
 * over Cycle bars smoothed by an EMA over %D (PF). The EMAs start as in TV;
 * a flat window keeps the previous stochastic.
 */
export default {
  id: "schaff-trend-cycle",
  name: "Schaff Trend Cycle",
  isOscillator: true,
  decimals: 2,
  inputs: [
    periodInput("fast", "Fast", 23),
    periodInput("slow", "Slow", 50),
    periodInput("cycle", "Cycle", 10),
    periodInput("macdSmoothing", "%D (MACD)", 3),
    periodInput("pfSmoothing", "%D (PF)", 3),
  ],
  plots: [
    linePlot("value", "Main Line", PALETTE.BLUE),
  ],
  buffers: ["fastEma", "slowEma", "macd", "macdStochastic", "pf", "pfStochastic"],
  levels: [level(75, PALETTE.AQUA), level(25, PALETTE.YELLOW)],

  calculate: (bars, { fast, slow, cycle, macdSmoothing, pfSmoothing }, series, fromIndex) => {
    const range = { period: cycle, fromIndex, toIndex: bars.length };

    fillMacdLine({ bars, fastPeriod: fast, slowPeriod: slow, averages: series, target: series.macd, fromIndex });
    fillSmoothedStochastic({
      ...range,
      source: series.macd,
      target: series.macdStochastic,
      smoothed: series.pf,
      smoothing: macdSmoothing,
    });
    fillSmoothedStochastic({
      ...range,
      source: series.pf,
      target: series.pfStochastic,
      smoothed: series.value,
      smoothing: pfSmoothing,
    });
  },
};
